import { type ConsentDto } from '@numa-group/apis.guest';
import { AnalyticsBrowser } from '@segment/analytics-next';

import { Integrations, TrackingEvent } from '@src/features/analytics/types';
import { segmentEnrichmentPlugin } from '@src/features/analytics/utils/segment-enrichment-plugin';
import { Brand } from '@src/types/content/brand';

export type IdentificationTraits = {
  guestId: string;
  email: string;
  profileId?: string;
  firstName?: string;
  lastName?: string;
  consents?: ConsentDto[];
};

export class SegmentService {
  constructor(private analytics: AnalyticsBrowser) {}

  async load(segmentId: string, integrations: Integrations, brand: Brand) {
    this.analytics = this.analytics.load(
      {
        writeKey: segmentId,
      },
      {
        integrations,
      },
    );
    await this.analytics.ready();
    await this.analytics.register(segmentEnrichmentPlugin(brand));
  }

  async trackPage(additionalProperties: Record<string, unknown> = {}) {
    await this.analytics.page(undefined, undefined, additionalProperties);
  }

  async trackEvent(event: TrackingEvent) {
    // eslint-disable-next-line
    (<any>window)?.dataLayer?.push({ event: event.event, ...event.properties });
    await this.analytics.track(event.event, event.properties ?? {});
  }

  async trackIdentification(
    identificationTraits: IdentificationTraits,
    additionalProperties: Record<string, unknown> = {},
  ) {
    await this.analytics.identify(identificationTraits.guestId, {
      guest_id: identificationTraits.guestId,
      profile_id: identificationTraits.profileId,
      is_logged_in: !!identificationTraits.profileId,
      email: identificationTraits.email,
      first_name: identificationTraits.firstName,
      last_name: identificationTraits.lastName,
      ...additionalProperties,
    });
  }
}
